import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import LanguageContext from '../../context/LanguageContext';
import { useStorePath } from '../../lib/storefront/storePath.js';
import './AuthCallback.css';

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const storePath = useStorePath();
    const { refreshUser } = useContext(AuthContext);
    const { currentLanguage } = useContext(LanguageContext);
    const [status, setStatus] = useState('Processing Google sign-in...');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userRaw = params.get('user');

        if (!token || !userRaw) {
            setStatus('Missing token or user data. Redirecting to login...');
            setTimeout(() => navigate(storePath(`/${currentLanguage || 'en'}/sign-in`), { replace: true }), 1500);
            return;
        }

        try {
            const user = JSON.parse(decodeURIComponent(userRaw));
            localStorage.setItem('token', token);
            if (user?.id) {
                localStorage.setItem('userId', user.id);
            }
            refreshUser();
            setStatus('Login successful. Redirecting to profile...');
            setTimeout(
                () => navigate(storePath(`/${currentLanguage || 'en'}/profile`), { replace: true }),
                500,
            );
        } catch (err) {
            console.error('Failed to parse user from callback', err);
            setStatus('Something went wrong. Redirecting to login...');
            setTimeout(() => navigate(storePath(`/${currentLanguage || 'en'}/sign-in`), { replace: true }), 1500);
        }
    }, [location.search, navigate, refreshUser, currentLanguage, storePath]);

    return (
        <main className='main auth-main'>
            <section className='auth-callback-section'>
                <div className='login-container container'>
                    <p className="auth-callback-status">{status}</p>
                </div>
            </section>
        </main>
    );
};

export default AuthCallback;
